export default {"src":"/_next/static/media/dimension-logo.a93cba67.svg","height":52,"width":193,"blurWidth":0,"blurHeight":0};